import { type EmployeeLevel } from "@prisma/client";
import { type AppContext } from "~/lib/context";
import { type MarketOrCompareInput } from "~/pages/api/get-market-data-stats";

import { resolveWeightedJobs } from "~/services/job";
import { generateEmployeesWithFiltersOptions } from "~/services/market-data/generateEmployeesWithFiltersOptions";
import { validateJobsAuthorised } from "~/services/market-data/validateJobsAuthorised";

export const formatInputToMarketDataInput = async (
  ctx: AppContext,
  params: {
    market: MarketOrCompareInput;
    levels: EmployeeLevel[];
    benchmarkLevelsRange: {
      min: number;
      max: number;
    };
    useTestData: boolean;
    mergeAdvancedLevels: boolean;
    canAccessFiguresAiV2: boolean;
    useBenchmarkLevelsInShare?: boolean;
  }
) => {
  const { market, useTestData, mergeAdvancedLevels, canAccessFiguresAiV2, useBenchmarkLevelsInShare } = params;

  const marketWeightedJobs = await resolveWeightedJobs(ctx, market, { useTestData });
  const marketJobsIds = marketWeightedJobs.map((item) => item.job.id);
  const employeesWithFiltersOptions = generateEmployeesWithFiltersOptions({
    mergeAdvancedLevels,
    levels: params.levels,
    benchmarkLevelsRange: params.benchmarkLevelsRange,
    useTestData,
    marketOrCompare: market,
    jobIds: marketJobsIds,
    options: { canAccessFiguresAiV2 },
    useBenchmarkLevelsInShare,
  });

  await validateJobsAuthorised(ctx, marketJobsIds);

  return {
    marketJobsIds,
    employeesWithFiltersOptions,
    marketWeightedJobs,
  };
};
